import React from 'react';

export const SeatDemo = () => {
    return (
        <div className="flex align-items-center py-5 px-3">
            <i className="pi pi-fw pi-ticket mr-2 text-2xl" />
            <p className="m-0 text-lg">Seat Component Content via Child Route</p>
        </div>
    )
}
